var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxTurkish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Turkish flag icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-LFM-flow-\\u2013-Rewe-case",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1a.-Language-selection-\\u2013-LFM-\\u2013-Rewe-\\u2013-mvp",
    transform: "translate(-16.000000, -629.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "::-Body",
    transform: "translate(0.000000, 330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "px-turkish",
    transform: "translate(16.000000, 299.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3172564,8.00009206 C21.6700666,3.33936768 17.2248927,0 12.0000218,0 C6.77509277,0 2.3300206,3.33936768 0.682830811,8.00009206 C0.240639136,9.25116846 0,10.5976138 0,12.0000218 C0,13.4024298 0.240639136,14.7488751 0.682830811,15.9999661 C2.3300206,20.660705 6.77509277,24 12.0000218,24 C17.2248927,24 21.6700666,20.660705 23.3172564,15.9999661 C23.7594335,14.7488751 24,13.4024298 24,12.0000218 C24,10.5976138 23.7594335,9.25116846 23.3172564,8.00009206",
    id: "Fill-3",
    fill: "#E20A17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0623214,16.4963615 C8.57903595,16.4963615 6.56596711,14.4833072 6.56596711,12.0000218 C6.56596711,9.51673639 8.57903595,7.50368208 11.0623214,7.50368208 C12.1753228,7.50368208 13.1936966,7.90810991 13.9789171,8.57801845 C13.0242099,7.48376812 11.6196215,6.79234669 10.0533958,6.79234669 C7.17734024,6.79234669 4.84577885,9.1238354 4.84577885,12.0000218 C4.84577885,14.8762082 7.17734024,17.2077405 10.0533958,17.2077405 C11.6196215,17.2077405 13.0242099,16.5162755 13.9789171,15.4220252 C13.1936966,16.0919773 12.1753228,16.4963615 11.0623214,16.4963615",
    id: "Fill-4",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-5",
    fill: "#EDEDED",
    points: "15.8173972 9.42501588 17.0904371 10.8641993 18.8479532 10.0875548 17.8726052 11.74303 19.1542211 13.174364 17.2783842 12.7583512 16.3132112 14.4196407 16.1291888 12.5071737 14.2508808 12.1024988 16.0130482 11.3364654 15.8173972 9.42501588"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxTurkish);
export default __webpack_public_path__ + "static/media/px-turkish.5d40209166b93b28da5b302abec01b6d.svg";
export { ForwardRef as ReactComponent };